import React from 'react';
import Markup from '../Markup';

export default function Panel(props)
{
  return(
    <div className="panel panel-default">
        <div className="panel-heading">
            <h3 className="panel-title">{props.title}</h3>
        </div>
        <div className="panel-body">
          <Markup>
            {props.text}
          </Markup>
            <p>
              <a className="btn btn-success pull-right" href="https://zzlx.org" >
                详情 &raquo;
              </a>
            </p>
      </div>
    </div>
  )
}




// WEBPACK FOOTER //
// ./usr/lib/ui/src/components/bootstrap/Panel.js